import { ChangeDetectionStrategy, Component, computed, inject, input, linkedSignal, output } from '@angular/core';

import { SynopticStandardUtils } from '@connect-services/client/components/synoptic/synoptic-graph/synoptic-standard-color.utils';
import { ColorEnum } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.constants';
import { SynopticPlanItem } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.models';
import { SideFiberEditComponent } from '@connect-services/client/components/synoptic/synoptic-plan/synoptic-plan-edit/side-cables-edit/side-tube-edit/side-fiber-edit/side-fiber-edit.component';
import { CableDirectionEnum, PlanTypeEnum, SynopticBoxPlanFiber } from '@connect-services/client/sdk/api';
import { SynopticPlanEditService } from '@connect-services/client/services/synoptic/edit/synoptic-plan-edit.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule, SideFiberEditComponent],
    selector: 'app-side-tube-edit',
    styleUrl: '../../synoptic-plan-edit.component.scss',
    templateUrl: './side-tube-edit.component.html',
})
export class SideTubeEditComponent {
    public readonly areAllFibersAssigned = input.required<boolean>();
    public readonly cableCode = input.required<string>();
    public readonly cassettes = input.required<SynopticPlanItem[][]>();
    public readonly fibers = input.required<SynopticBoxPlanFiber[]>();
    public readonly isOpen = input.required<boolean>();
    public readonly planType = input.required<PlanTypeEnum>();
    public readonly side = input.required<CableDirectionEnum>();
    public readonly toggle = output<void>();
    public readonly tubeNumber = input.required<number>();

    protected readonly fontColor = computed<string>(() => {
        return SynopticStandardUtils.getFontColor(this.tubeColor());
    });
    protected readonly isTubeSelected = computed<boolean>(() => {
        const selectedElement = this.synopticPlanEditService.selectedTubeAnchor();
        if (!selectedElement) {
            return false;
        }

        return selectedElement.cableCode === this.cableCode() && selectedElement.tubeIndex === this.tubeNumber();
    });
    protected readonly isTubeSelectionEnabled = computed<boolean>(() => {
        const cassetteAnchor = this.synopticPlanEditService.selectedCassetteAnchor();

        return !this.areAllFibersAssigned() && (!cassetteAnchor || cassetteAnchor.side === this.side());
    });
    protected readonly shouldOpenedTube = linkedSignal<boolean>(() => this.isOpen());
    protected readonly tubeColor = computed<ColorEnum>(() => {
        return SynopticStandardUtils.formatColor(this.tubeNumber());
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    protected readonly CableDirectionEnum = CableDirectionEnum;

    private readonly synopticPlanEditService = inject(SynopticPlanEditService);

    protected selectTube(): void {
        if (this.isTubeSelected()) {
            this.synopticPlanEditService.selectedTubeAnchor.set(null);

            return;
        }

        this.synopticPlanEditService.selectedTubeAnchor.set({
            cableCode: this.cableCode(),
            side: this.side(),
            tubeIndex: this.tubeNumber(),
        });
    }

    protected toggleTube(): void {
        if (this.isOpen()) {
            return;
        }

        this.shouldOpenedTube.update((previousValue: boolean) => !previousValue);
        this.toggle.emit();
    }
}
